<template>
  <v-layout row>
    <v-flex xs12 mb-6>
      <v-list v-if="allEvaluations" two-line>
        <template v-for="evaluation in allEvaluations.nodes">
          <v-list-tile
            :key="evaluation.id"
            avatar
            @click="onClickEvaluation(evaluation)"
          >
            <v-list-tile-content>
              <v-list-tile-title>
                <v-layout row justify-space-between>
                    <div>{{evaluation.templateByTemplateId.title}}</div>
                    <div class="body-1">
                      <span v-if="evaluation.endTime">
                        {{$d(new Date(evaluation.startTime), 'long')}}
                      </span><span v-else class="grey--text">
                        {{$d(new Date(evaluation.startTime), 'long')}}
                      </span>
                    </div>
                </v-layout>
              </v-list-tile-title>
              <v-list-tile-sub-title>
                <v-layout row justify-space-between>
                  <div>
                    <span v-if="evaluation.teamByTeamId" class="black--text">{{evaluation.teamByTeamId.name}}</span>
                    <span v-for="(participation, index) in sortParticipations(evaluation.participationsByEvaluationId.nodes)" :key="index">
                      <span v-if="index != 0">, </span>
                        {{participation.participantRoleByRoleId.title}}
                        {{participation.participantByParticipantId.fullName}}</span>
                  </div>
                  <div v-if="evaluation.userByEvaluatorUserId" class="text-xs-right">
                    {{evaluation.userByEvaluatorUserId.fullName}}
                  </div>
                </v-layout>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
      <div v-if="allEvaluations && allEvaluations.nodes.length === 0">
        <p class="grey--text px-3">
          {{$t('evaluationListEmpty')}}
        </p>
      </div>
    </v-flex>
  </v-layout>
</template>



<script>
import {  allEvaluationsBasicQuery } from '@/graphql/evaluationQueries.gql'
//import { allTemplateTitles, ... , ... } from '@/graphql/templateQueries.gql'
//allEvaluationsQuery,

export default {
  apollo: {
      allEvaluations: allEvaluationsBasicQuery,
      //allEvaluationsBasic: allEvaluationsBasicQuery
  },
  data() { return {
      allEvaluations: null,
  }},
  methods: {
    sortParticipations(participations) {
      return participations && participations.concat().sort((a,b) => a.participantRoleByRoleId.sortWeight - b.participantRoleByRoleId.sortWeight)
    },
    onClickEvaluation(clickedEvaluation) {
      if (clickedEvaluation.endTime) {
        this.$router.push({ name: 'result', params: {evaluationId: clickedEvaluation.id}})
      } else {
        this.$router.push({ name: 'evaluation', params: {evaluationId: clickedEvaluation.id}})
      }
    }
  }
}
</script>
